module.exports = __webpack_public_path__ + "img/energy.6bfbe8f7.png";